import { render, staticRenderFns } from "./OrderBuyConfirm.vue?vue&type=template&id=23aaa813&"
import script from "./OrderBuyConfirm.vue?vue&type=script&lang=ts&"
export * from "./OrderBuyConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports